<template>
  <div id="app">
    <UniquittyHeader></UniquittyHeader>
    <about></about>
    <create-cat-form></create-cat-form>
    <div class="display-data">
      <cats></cats>
    </div>
  </div>
</template>

<script>
import UniquittyHeader from './components/furniture/Header';
import Cats from './components/cats/Index';
import CreateCatForm from './components/cats/Create';
import Unique from './components/cats/Unique';
import About from './components/furniture/About';

export default {
  name: 'app',
  components: {
    Cats,
    CreateCatForm,
    Unique,
    UniquittyHeader,
    About
  },
};
</script>

<style>

  *{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  html{
    font-family: sans-serif;
  }
  body{
    background: #272727;
    padding: 0 16px;
  }
  .display-data {
    display: flex;
    justify-content: space-around;
  }
  h4 {
    padding-top:50px;
    font-size:30px;
    padding-bottom: 30px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// App.vue?4fdb82e3